import { brandService } from './brand';

export interface ExternalApp {
  /** Doubles as the `mainView` value while this app is open. */
  id: string;
  label: string;
  url: string;
  /** Brand ids that should see this app (empty = every brand). */
  brands: string[];
}

/**
 * Sibling apps deployed next to this one. Rendered in the browser, so it must
 * stay non-secret (same rule as the brand profile — see docs/TROUBLESHOOTING.md §5).
 *
 * An app can only be embedded if its origin does NOT send `X-Frame-Options` or a
 * CSP `frame-ancestors` — verified for horse-dance-ai.feelingss.ai.
 */
export const EXTERNAL_APPS: ExternalApp[] = [
  {
    id: 'horseDance',
    label: 'Horse Dance AI',
    url: 'https://horse-dance-ai.feelingss.ai/',
    // Visible on feelingss (its own subdomain) and on mednnect for local testing;
    // narrow this list if the mednnect deployment should not link out.
    brands: ['feelingss', 'mednnect'],
  },
];

export function getVisibleExternalApps(): ExternalApp[] {
  const brandId = brandService.getProfile()?.id || '';
  return EXTERNAL_APPS.filter((app) => app.brands.length === 0 || app.brands.includes(brandId));
}

export function getExternalApp(id: string): ExternalApp | undefined {
  return EXTERNAL_APPS.find((app) => app.id === id);
}
